// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueCookie from 'vue-cookie'
import App from './App'
import router from './router'
import store from './store/store'
import './vee-validate'
import VCalendar from 'v-calendar'
import VueMask from 'v-mask'
import autofocus from 'vue-autofocus-directive'
import ClickOutside from 'vue-click-outside'
import VueSocketIO from 'vue-socket.io'
import {SOCKET_SERVER} from '@/constants/domains'

Vue.directive('autofocus', autofocus)
Vue.directive('ClickOutside', ClickOutside)

Vue.config.productionTip = false
Vue.use(VueCookie)
Vue.use(VCalendar)
Vue.use(VueMask)

Vue.use(new VueSocketIO({
  debug: false,
  connection: SOCKET_SERVER
}))

/* eslint-disable no-new */
const vue = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
window.vue = vue



// WEBPACK FOOTER //
// ./src/main.js